import { render, staticRenderFns } from "./DeliveryReceiptEdit.vue?vue&type=template&id=54bfc5b6&"
import script from "./DeliveryReceiptEdit.vue?vue&type=script&lang=js&"
export * from "./DeliveryReceiptEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports